<template>
  <div>
    <div>
      <SjImage
        src="error"
        :imageStyle="{ width: '40px', height: '40px' }"
        round
      />
    </div>
    <div>
      <SjImage
        src="error"
        label="error"
        :imageStyle="{ width: '40px', height: '40px' }"
        round
      />
    </div>
    <div>
      <SjImage
        :localSrcPath="localPath"
        :imageStyle="{ width: '40px', height: '40px' }"
      />
    </div>
    <div>
      <SjImage :src="url" :imageStyle="{ width: 'auto', height: '40px' }" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localPath: import("../../../assets/image/logo.png"),
      url: "https://www.baidu.com/img/bd_logo1.png?where=super"
    };
  }
};
</script>

<style scoped lang="less"></style>
